module.exports = {"npc_death":"","player_death":"","player_spell":""};